import { Alert, Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface StockForm {
  quantity_owned: string;
  quantity_available: string;
}

interface ProductStockEditModalProps {
  show: boolean;
  stockName?: string;
  formData: StockForm;
  error: string | null;
  submitting: boolean;
  onClose: () => void;
  onSubmit: (event: React.FormEvent) => void;
  onChange: (field: keyof StockForm, value: string) => void;
}

const ProductStockEditModal = ({ show, stockName, formData, error, submitting, onClose, onSubmit, onChange }: ProductStockEditModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t('warehouses.products.editStock')}{stockName ? `: ${stockName}` : ''}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={onSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger" className="mb-3">{error}</Alert>}
          <Row className="g-3">
            <Col md={6}>
              <Form.Group controlId="stock-quantity-owned">
                <Form.Label>{t('warehouses.products.owned')}</Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  value={formData.quantity_owned}
                  onChange={(e) => onChange('quantity_owned', e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="stock-quantity-available">
                <Form.Label>{t('warehouses.products.available')}</Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  value={formData.quantity_available}
                  onChange={(e) => onChange('quantity_available', e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={submitting}>
            {t('common.cancel')}
          </Button>
          <Button variant="primary" type="submit" disabled={submitting}>
            {submitting ? t('common.saving') : t('common.save')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ProductStockEditModal;
